export default __webpack_public_path__ + "static/media/fondo_inicio.2039950c.jpg";